// @ts-nocheck
import styled from 'styled-components';

export const SpaceSideWrestlerCssComponent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.alignItems || 'center'};
    justify-content: ${props => props.justifyContent || 'center'};
    width: 33.33%;
    height: 100%;
    padding: ${props => props.padding || '0 10px'};
`;
